import React from 'react';
import {Button} from 'react-admin';
import GetAppIcon from '@material-ui/icons/GetApp';
import {connect} from 'react-redux';
import {documentCreateRequest} from '../../actions/documentActions';
import {useTranslation} from 'react-i18next';
import {selectDocumentCreating} from '../../selectors/documentSelectors';

const ExportContactsButton = ({onClick, creating, record: {id}}) => {
    const {t} = useTranslation();

    return (
        <Button
            label={t('document.export_contacts')}
            onClick={(e) => {
                e.stopPropagation();
                onClick(id);
            }}
            disabled={creating}
        >
            <GetAppIcon/>
        </Button>
    );
};

const mapStateToProps = (state) => ({
    creating: selectDocumentCreating(state)
});

const mapDispatchToProps = (dispatch) => ({
    onClick: (groupId) => {
        dispatch(documentCreateRequest('contact_export', groupId));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportContactsButton);
